module.exports = __webpack_public_path__ + "img/img6.b532a642.png";